<div class="add-group">
  <div class="flex flex-row justify-between items-center">
    <div class="fs-24 fw-700 mat-subtitle-2 mb-0">{{'GROUPS.ADD_GROUP' | transloco}}</div>
    <mat-icon class="justify-items-end cursor-pointer icon-lg" (click)="closeSidenav()" svgIcon="close"></mat-icon>
  </div>
  <mat-divider class="neutral-2 mb-12 mt-20"></mat-divider>
  <div [ngClass]="{'disabled': showLoader}">
    <form [formGroup]="groupForm" (ngSubmit)="onSubmit()">
      <div class="form-section">
        <div class="flex flex-col form-group mat-subheading-2 mb-16">
          <div class="flex items-center mb-4">
            <label class="fw-700 fs-12" for="username">{{'GROUPS.GROUP_NAME' | transloco | uppercase}}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-8" matTooltipClass="form-tooltip right" [matTooltip]="'GROUPS.GROUP_NAME' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <input type="text" placeholder="{{'GROUPS.ENTER_GROUP_NAME' | transloco}}"
            formControlName="name" class="fw-500" required>
            <app-error [control]="groupForm.get('name')"></app-error>
        </div>
        <div class="flex flex-col form-group mat-subheading-2 mb-16">
          <div class="flex items-center mb-4">
            <label class="fw-700 fs-12" for="username">{{'GROUPS.DESCRIPTION' | transloco | uppercase}}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-8" matTooltipClass="form-tooltip right" [matTooltip]="'GROUPS.DESCRIPTION' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <textarea formControlName="description" placeholder="{{'GROUPS.DESCRIPTION_HERE' | transloco}}" class="fw-500 text-area" required></textarea>
            <app-error [control]="groupForm.get('description')"></app-error>
        </div>
      </div>
    

      <div class="fw-500 mat-subtitle-2">
        <span class="note-text mr-4">{{'GROUPS.NOTE' | transloco}}</span>
        <span>{{'GROUPS.NOTE_TEXT' | transloco}}</span>
        <span class="ml-4 click-text cursor-pointer" (click)="keycloakClick()">{{'GROUPS.CLICK_HERE' | transloco}}</span>
      </div>
      <mat-divider class="neutral-2 mt-12 mb-12"></mat-divider>
      <div class="flex flex-row justify-end w-100-percent">
        <button type="cancel" class="white" (click)="closeSidenav()">{{'DIALOG.CANCEL' | transloco}}</button>
        <button type="submit" class="accent ml-12" [ngClass]="{'disabled': (!groupForm.get('name').value || !groupForm.get('description').value)}">{{'TENANT_FORM.SUBMIT' | transloco}}</button>
      </div>
    </form>
  </div>
  <div *ngIf="showLoader">
    <mat-card class="flex spinner-container load-spinner">
      <mat-spinner diameter="24"
        color="primary"
        mode="indeterminate">
      </mat-spinner>
    </mat-card>
  </div>
</div>